import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import i18n from 'i18n';
import { Col, Nav, OverlayTrigger, Row, Tab, Tooltip } from 'react-bootstrap';
import AboutMockService from 'components/modal/wizard/AboutMockService';
import ServiceWizard from 'components/modal/wizard/ServiceWizard';
import Behavior from 'components/modal/wizard/Behavior';
import Configuration from 'components/modal/wizard/Configuration';
import Run from 'components/modal/wizard/Run';
import Leave from 'components/modal/wizard/Leave';
import { connect } from 'react-redux';
import { ApplicationState } from 'store/rootReducer';
import { MockServiceTransaction, MockServiceTxn, TRANSACTIONAL } from 'types/rest/mockServiceTypes';
import {
  HttpTransaction,
  Service,
  Transaction,
  TransactionTransferObjectWrapper,
  TransactionWrapper,
} from 'types/rest/assetCatalogTypes';
import { TransactionListState, WizardTransactionListState } from 'store/transactions/transactionsTypes';
import { transactionListInitialState } from 'store/transactions/transactionsReducer';
import _ from 'lodash';
import { ServiceType, WizardTransactionTypes, WzState } from 'components/modal/wizard/WizardTransactionTypes';
import { showToastNotification } from 'store/ui/toasts/toastsActions';
import { ToastType } from 'store/ui/toasts/toastsTypes';
import { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import axios from 'axios/axios-base';
import { cacheControlHeaders } from 'utils/miscUtil';
import { pollTrackingService } from 'axios/axios-polling';
import { BlazeMeterApiResponse } from 'types/rest/blazeMeterApiResponse';
import { createServiceThunk, fetchServices } from 'store/services/servicesActions';
import clsx from 'clsx';
import styles from './WizardModal.module.css';
import { getActiveWorkspaceId } from '../../utils/bzmUserConfigUtil';
import { setPageFilter } from 'store/ui/pageFilters/pageFilterActions';
import { PageFilterContent } from 'store/ui/pageFilters/pageFilterTypes';
import {
  getMockServiceListThunk,
  toggleExpandedMockServiceRow,
} from 'store/mockServices/mockServiceList/mockServiceListActions';
import { EmptyTransaction } from 'views/AssetCatalog/Transactions/TransactionEditor/TransactionEditor';
import MixpanelService from '../../utils/mixpanelService';
import { WIZARD_CLOSE, WIZARD_FINISHED } from '../../utils/mixpanelEvents';
import { MatcherDsl } from 'types/rest/dslTypes';
import acApi from '../../axios/ac/acApi';

interface WizardModalProps {
  onClose: (finishStepNr: number) => void;
  setFilter?: (serviceId: number, searchTerm: string) => void;
  /** Custom button appearing in the very end of the wizard. */
  doneButton?: any;
}

type AllProps = MapToStateProps & DispatchProps & WizardModalProps;

interface Workflow {
  id: number;
  name: string;
  done: boolean;
}

interface LocalState {
  showBackButton: boolean;
  showNextButton: boolean;
  activeTab: number;
  workflow: Workflow[];
  serviceIdOrName: ServiceType;
  service: number | string;
  mockService: MockServiceTxn | null;
  validService: boolean;
  wzTransactions: WizardTransactionListState;
  validTransaction: boolean;
  location: any;
  validLocation: boolean;
  mockServiceName: string;
  validMockService: boolean;
  lastTabSelected: number;
  configState: WzState;
  msEndpoint: string;
  creationInProgress: boolean;
  deployInProgress: boolean;
  deployError: string;
}

const initialState = (txListState: TransactionListState) => {
  return {
    showBackButton: false,
    showNextButton: true,
    activeTab: 1,
    workflow: [
      {
        id: 1,
        name: 'About Virtual Services',
        done: false,
      },
      {
        id: 2,
        name: 'Service',
        done: false,
      },
      {
        id: 3,
        name: 'Behavior',
        done: false,
      },
      {
        id: 4,
        name: 'Configuration',
        done: false,
      },
      {
        id: 5,
        name: 'Run',
        done: false,
      },
    ],
    service: '',
    serviceIdOrName: 'new' as ServiceType,
    mockService: null,
    validService: false,
    wzTransactions: txListState,
    validTransaction: true,
    location: { harborId: null, shipId: null },
    validLocation: false,
    mockServiceName: 'MockService',
    validMockService: true,
    lastTabSelected: 1,
    configState: 'inConfig',
    msEndpoint: '',
    creationInProgress: false,
    deployInProgress: false,
    deployError: '',
  } as LocalState;
};

class WizardModal extends Component<AllProps, LocalState> {
  initialWizardState = () => {
    //flag -2 for new service in wizard transaction
    const wzEmptyTx = new EmptyTransaction(
      'HTTP',
      -2,
      'Get Account Details',
      '/account/1',
      1,
      i18n.t('wizard:details.sampleContent'),
    ) as HttpTransaction;
    const wzTransactions = transactionListInitialState;
    wzTransactions.isLoading = false;
    wzTransactions.transactions = [wzEmptyTx];
    wzTransactions.totalTransactions = 1;
    this.setState(initialState(wzTransactions));
  };

  UNSAFE_componentWillMount() {
    this.initialWizardState();
  }

  closeTransactionEditorForCreate(
    wzTransactions: WizardTransactionListState,
    txId: number,
  ): WizardTransactionListState {
    wzTransactions.expandedTransactionId = txId; //to keep open created/updated transaction
    wzTransactions.isCreatingNewTransaction = false;
    return wzTransactions;
  }

  wizardTransactionActions = (action: WizardTransactionTypes, payload: any) => {
    let wzTransactions = _.cloneDeep(this.state.wzTransactions);
    switch (action) {
      case 'expandTransactionRow':
        wzTransactions.expandedTransactionId = payload.expandId;
        if (payload.expandId === null) {
          // to avoid update minutes, seconds in the name when expand/collapse
          wzTransactions.currentNewTxName = payload.txName;
        }
        this.setState({ wzTransactions: wzTransactions });
        break;
      case 'add':
        wzTransactions.isCreatingNewTransaction = true;
        wzTransactions.currentNewTxName = undefined; //to reset before creating new Tx
        const newTx = new EmptyTransaction('HTTP', this.state.service as number, wzTransactions.currentNewTxName, '/');
        //next sequential number or if empty starts with 2 (since 1 is reserved for pre created demo tx)
        if (!_.isNil(wzTransactions.transactions[0])) {
          newTx.id = (wzTransactions.transactions[0].id as number) + 1;
        } else {
          newTx.id = 2;
        }
        wzTransactions.expandedTransactionId = newTx.id;
        wzTransactions.transactions = _.concat([newTx as HttpTransaction] || [], wzTransactions.transactions);
        this.setState({ wzTransactions: wzTransactions });
        break;
      case 'save':
        wzTransactions.isCreatingNewTransaction = false;
        wzTransactions.expandedTransactionId = wzTransactions.transactions[0].id as number;
        wzTransactions.totalTransactions = wzTransactions.transactions.length;
        this.setState({ wzTransactions: wzTransactions, validTransaction: true });
        break;
      case 'update':
        const txWrapper2: TransactionWrapper = payload;
        const index = _.findIndex(wzTransactions.transactions, { id: txWrapper2.transaction.id });
        if (index !== undefined) {
          wzTransactions.transactions.splice(index, 1, txWrapper2.transaction as HttpTransaction);
        }
        wzTransactions.isCreatingNewTransaction = false;
        wzTransactions.expandedTransactionId = txWrapper2.transaction.id as number;
        this.setState({ wzTransactions: wzTransactions, validTransaction: true });
        break;
      case 'closeTx':
        wzTransactions = this.closeTransactionEditorForCreate(
          wzTransactions,
          wzTransactions.expandedTransactionId as number,
        );
        wzTransactions.currentNewTxName = undefined;
        wzTransactions.isCreatingNewTransaction = false;
        this.setState({ wzTransactions: wzTransactions });
        break;
      case 'deleteTx':
        const transaction: Transaction = payload;
        _.remove(wzTransactions.transactions, function(tx) {
          return tx.id === transaction.id;
        });
        if (transaction.id !== -1) {
          this.props.showToastNotification(
            ToastType.Success,
            '',
            `${i18n.t('transactions:actions.successfullyDeletedTxn')} ${transaction.name}`,
          );
        } else {
          wzTransactions.isCreatingNewTransaction = false;
        }
        wzTransactions.totalTransactions = wzTransactions.transactions.length;
        this.setState({ wzTransactions: wzTransactions, validTransaction: true });
        break;
      case 'invalidTx':
        this.setState({ validTransaction: false });
        break;
      default:
      //something here?
    }
  };

  resolveBorder = (done: boolean): string => {
    return this.state.creationInProgress || done === true ? '4px solid #8952FF' : '4px solid #EEEEEE';
  };

  resolveBackground = (wfId: number): string | undefined => {
    return wfId === this.state.activeTab ? '#C0A0FF' : this.validateTabs(wfId) ? 'none' : undefined;
  };

  resolveDisable = (wfId: number): boolean => {
    return wfId === this.state.activeTab ? false : this.validateTabs(wfId);
  };

  resolveCursor = (wfId: number): string => {
    return this.validateTabs(wfId) ? 'default' : 'pointer';
  };

  onLeaveSelected = () => {
    this.setState({
      lastTabSelected: this.state.activeTab !== 6 ? this.state.activeTab : this.state.lastTabSelected,
      activeTab: 6,
      showBackButton: false,
      showNextButton: false,
    });
  };

  isInvalidService = () => {
    return this.state.service.toString().trim() === '' || !this.state.validService;
  };

  isInvalidBehavior = () => {
    return (
      this.state.wzTransactions.isCreatingNewTransaction === true ||
      this.state.wzTransactions.transactions.length < 1 ||
      !this.state.validTransaction
    );
  };

  isInvalidConfiguration = () => {
    return !this.state.validMockService || !this.state.validLocation;
  };

  validateTabs = (tabId: number) => {
    const editingService = this.isInvalidService();
    const editingBehavior = this.isInvalidBehavior();
    const editingConfiguration = this.isInvalidConfiguration();
    return !!(
      (tabId > 2 && editingService) ||
      (tabId > 3 && editingBehavior) ||
      (tabId > 4 && editingConfiguration) ||
      this.state.creationInProgress
    );
  };

  setNewState = (tabId: number) => {
    if (this.validateTabs(tabId)) {
      return;
    }
    const showBack = tabId !== 1; //false when 1.
    const showNext = tabId !== 5; //only false on 5.

    const updateWf: Workflow[] = this.state.workflow.map((wf: Workflow) => ({
      id: wf.id,
      name: wf.name,
      done: wf.id <= tabId - 1, //to paint green line in the previous step
    }));

    this.setState({
      showBackButton: showBack,
      showNextButton: showNext,
      activeTab: tabId,
      workflow: updateWf,
    });
  };

  nextAction = () => {
    const wFlow: Workflow = this.state.workflow[this.state.activeTab]; //because activeTab start in 1, array in 0
    this.setNewState(wFlow.id);
  };

  backAction = () => {
    const wFlow: Workflow = this.state.workflow[this.state.activeTab - 2]; //because activeTab start in 1, array in 0
    this.setNewState(wFlow.id);
  };

  //code for second phase
  handleServiceChange = (selectedId: number) => {
    //this is for service picker, to do: define logic for 'isValid' param if necessary
    this.setServiceState('byId', selectedId, true);
  };

  setServiceState = (idOrName: ServiceType, service: number | string, isvalid: boolean) => {
    this.setState({
      serviceIdOrName: idOrName,
      service: service,
      validService: isvalid,
      mockServiceName: 'MockService_' + (service as string),
    });
  };

  resolveDisableButtons = (activeTab: number) => {
    let disableBack = activeTab === 1; //disable for step 1, others enable,
    let disableNext = activeTab !== 1; //enable for step 1, others check conditions.
    let hintMsg = '';
    switch (activeTab) {
      case 2:
        if (!this.isInvalidService()) {
          disableNext = false;
        } else {
          hintMsg = i18n.t('wizard:tooltip.service');
        }
        break;
      case 3:
        if (
          !(
            this.state.wzTransactions.isCreatingNewTransaction ||
            this.state.wzTransactions.transactions.length < 1 ||
            !this.state.validTransaction
          )
        ) {
          disableNext = false;
        } else {
          hintMsg = i18n.t('wizard:tooltip.behavior');
        }
        break;
      case 4:
        if (this.state.validMockService && this.state.validLocation) {
          disableNext = false;
        } else {
          hintMsg = i18n.t('wizard:tooltip.mockService');
        }
        break;
      case 5:
        if (this.state.creationInProgress === true) {
          disableBack = true;
          hintMsg = i18n.t('wizard:tooltip.run');
        }
        break;
    }
    return { disableBack: disableBack, disableNext: disableNext, hintMsg: hintMsg };
  };

  locationChanged = (location: any) => {
    if (location !== null && location.harborId !== null && location.shipId !== null) {
      this.setState({
        location: { harborId: location.harborId, shipId: location.shipId, shipName: location.shipName },
        validLocation: true,
      });
    } else {
      this.setState({ validLocation: false });
    }
  };

  updateMockServiceName = (msName: string, isValid: boolean) => {
    this.setState({ mockServiceName: msName, validMockService: isValid });
  };

  getInitLocation = (location: BlazeDropdownItem) => {
    if (this.state.location.shipId === null) {
      this.locationChanged(location.metaData ? location.metaData : '');
    }
  };

  executeWizard = async () => {
    try {
      this.setState({ creationInProgress: true });
      //save Service
      const serv = await this.saveService();
      const serviceId = serv.data.result.id ? serv.data.result.id : 0;

      //save Transactions
      const txIdList: MockServiceTransaction[] = await this.saveTransactions(serviceId);

      //Save Virtual Service
      const msId = await this.saveMockService(txIdList, serviceId);

      //ui update selected Service and its components
      await this.updateServiceList(serviceId, msId);

      this.setState({ deployInProgress: true });

      //deploy Virtual Service
      const result = await this.deployMs(serviceId, msId);
      this.setState(
        {
          configState: result.success ? 'running' : 'created',
          deployError: result.error,
          showBackButton: false,
        },
        () => {
          MixpanelService.track(WIZARD_FINISHED());
        },
      );
    } catch (error) {
      const errorMsg = _.get(error, 'response.data.error', error.toString());
      //this.props.showToastNotification(ToastType.Danger, '', errorMsg);
      console.error(errorMsg);
      this.setState({ configState: 'error', showBackButton: false });
    }
  };

  //to refresh and select in servicePicker new created service
  private async updateServiceList(serviceId: number, msId: number) {
    // Refresh list
    await this.props.fetchVirtualServices(true);
    // Reset search filter immediately on mount
    await this.props.setPageFilter({
      serviceId: serviceId,
      searchTerm: '',
    });
    // Filter SM and SmTemplate lists by this service if available
    if (this.props.setFilter) {
      await this.props.setFilter(serviceId, '');
    }

    this.props.toggleExpandedMockServiceRow(msId);
  }

  saveService = async () => {
    const service: Service = { name: this.state.service as string, workspaceId: getActiveWorkspaceId() };
    return await axios.post('/workspaces/{workspaceId}/services', service);
  };

  saveTransactions = async (serviceId: number) => {
    const txResp = await axios.post<BlazeMeterApiResponse>(
      `workspaces/{workspaceId}/transactions`,
      { transactions: this.state.wzTransactions.transactions } as TransactionTransferObjectWrapper,
      {
        params: {
          serviceId: serviceId,
        },
      },
    );
    return txResp.data.result.map((rs: any) => {
      return { txnId: rs.id, priority: 1 };
    });
  };

  saveMockService = async (txIdList: MockServiceTransaction[], serviceId: number) => {
    const mockServiceToCreate = {
      id: null,
      serviceId: serviceId,
      name: this.state.mockServiceName,
      harborId: this.state.location.harborId,
      shipId: this.state.location.shipId,
      replicas: 1,
      endpointPreference: 'HTTPS',
      mockServiceTransactions: txIdList,
      noMatchingRequestPreference: 'return404',
      type: TRANSACTIONAL.toString(),
      httpRunnerEnabled: true,
      httpRunnerOverrideKeystore: true,
      httpRunnerOverrideTruststore: true,
    };
    const msResp = await axios.post(`/workspaces/{workspaceId}/service-mocks`, mockServiceToCreate);
    return msResp.data.result.id;
  };

  deployMs = async (serviceId: number, serviceMockId: number) => {
    try {
      const deployResponse = await acApi.mockServices.deploy(serviceMockId, {
        headers: cacheControlHeaders,
      });
      if (
        !deployResponse ||
        !deployResponse.data ||
        !deployResponse.data.result ||
        !deployResponse.data.result.trackingId
      ) {
        throw new Error(i18n.t('mockServices:errorMsgs.errorRetrevingTrackingId'));
      }

      const trackingId = deployResponse.data.result.trackingId;
      const trackingResult = await pollTrackingService(trackingId);
      const errorMsg: string[] = _.get(trackingResult, 'data.result.errors');
      if (!_.isEmpty(errorMsg)) {
        throw new Error(errorMsg.join());
      }

      //Get the newly deployed virtual service
      const deployedServiceResponse = await axios.get(`/workspaces/{workspaceId}/service-mocks/${serviceMockId}`, {
        headers: cacheControlHeaders,
      });

      //ui update Virtual Service list
      this.props.getMockServiceListThunk();

      const deployedMockService = deployedServiceResponse.data.result;
      if (deployedServiceResponse.status === 200 && deployedServiceResponse.data.result.status !== 'FAILED') {
        const newEndpoint =
          deployedMockService.endpointPreference === 'HTTPS'
            ? deployedMockService.httpsEndpoint
            : deployedMockService.httpEndpoint;
        this.setState({ msEndpoint: newEndpoint });
        return { success: true, error: '' };
      } else {
        throw new Error(i18n.t('errorMsgs.networkProblem'));
      }
    } catch (error) {
      const errorBody = _.get(error, 'response.data.error', error.message);
      return { success: false, error: errorBody };
    }
  };

  onCloseHandler = (defaultEvent?: boolean) => {
    let step = this.state.lastTabSelected;
    switch (this.state.configState) {
      case 'running':
      case 'created':
        step = 6;
        break;
      case 'error':
        step = 7;
        break;
    }
    if (defaultEvent !== true) {
      this.props.onClose(step);
      MixpanelService.track(WIZARD_CLOSE(step));
    }
  };

  render() {
    const resolver = this.resolveDisableButtons(this.state.activeTab);
    let queryParams: MatcherDsl[] | string = '';
    let exampleURL = '';
    if (
      this.state.wzTransactions.transactions !== undefined &&
      this.state.wzTransactions.transactions[0] !== undefined
    ) {
      const txWithGetRequest = _.find(this.state.wzTransactions.transactions, tx => tx.dsl.requestDsl.method === 'GET');
      if (txWithGetRequest) {
        if (
          txWithGetRequest.dsl.requestDsl.queryParams !== undefined &&
          txWithGetRequest.dsl.requestDsl.queryParams.length > 0
        ) {
          queryParams =
            '?' +
            (txWithGetRequest.dsl.requestDsl.queryParams as MatcherDsl[])
              .map(q => {
                return q.key + '=' + q.matchingValue;
              })
              .join('&');
        }
        exampleURL = this.state.msEndpoint + txWithGetRequest.dsl.requestDsl.url.matchingValue + queryParams;
      }
    }

    return (
      <Modal
        dialogClassName={'mock-service-wizard-modal'}
        size={'lg'}
        show={true}
        centered={true}
        backdrop={true}
        onHide={() => this.onCloseHandler(true)}
      >
        <Row style={{ minHeight: 650 }}>
          <Col md={4} lg={3} xs={12} className={clsx(styles.modalMenuBorder, 'bg-light')}>
            <div className={'position-relative p-3 pt-6 h-100'}>
              <h2 style={{ marginLeft: '15px' }}>{i18n.t('wizard:menu.create')}</h2>
              <Nav style={{ marginLeft: '15px' }} variant="pills" className="flex-column">
                {this.state.workflow.map((wf: Workflow) => (
                  <Nav.Item
                    key={wf.id}
                    style={{
                      borderLeft: this.resolveBorder(wf.done), //mark border steps done with green
                      backgroundColor: this.resolveBackground(wf.id), //mark current background step with darker gray
                      cursor: this.resolveCursor(wf.id), //change cursor only when step clickable,
                    }}
                    className={clsx(styles.stepSelectable)}
                  >
                    <Nav.Link
                      disabled={this.resolveDisable(wf.id)}
                      style={{
                        marginTop: '5px',
                        color: 'black',
                        backgroundColor: this.resolveBackground(wf.id), //mark current background step with darker gray
                        cursor: this.resolveCursor(wf.id), //change cursor only when step clickable,
                      }}
                      eventKey={wf.id}
                      onSelect={() => this.setNewState(wf.id)}
                    >
                      {wf.id} <span className={'ml-5'}>{wf.name}</span>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
              {/*purpose: remove leave link once MS creation starts or if unexpected error occurs*/}
              {this.state.configState !== 'error' && this.state.creationInProgress === false && (
                <div className={clsx(styles.linkStyle, 'text-center p-4')}>
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                      <Button className={'ml-3'} variant="link" onClick={this.onLeaveSelected}>
                        {i18n.t('wizard:menu.leave')}
                      </Button>
                    </Nav.Item>
                  </Nav>
                </div>
              )}
            </div>
          </Col>
          <Col md={8} lg={9} xs={12}>
            <div className={clsx(styles.wizardContent, 'position-relative pt-6 pr-5 h-100')}>
              {/*purpose: disable cross during deploying, available again afterward*/}
              <button
                disabled={this.state.creationInProgress && this.state.configState === 'inConfig'}
                className={clsx('close', styles.closeButton)}
                onClick={this.state.configState === 'inConfig' ? this.onLeaveSelected : () => this.onCloseHandler()}
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <Tab.Container id="left-tabs-example" activeKey={this.state.activeTab} mountOnEnter={true}>
                <Tab.Content className={'h-100'}>
                  <Tab.Pane eventKey="1">
                    <AboutMockService />
                  </Tab.Pane>
                  <Tab.Pane eventKey="2">
                    <ServiceWizard
                      services={this.props.services}
                      service={this.state.service}
                      idOrName={this.state.serviceIdOrName}
                      handleServiceChange={this.handleServiceChange}
                      setServiceState={this.setServiceState}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="3">
                    <Behavior
                      idOrName={this.state.serviceIdOrName}
                      service={this.state.service}
                      transactions={this.state.wzTransactions}
                      wizardTransactionActions={this.wizardTransactionActions}
                      validTransaction={this.state.validTransaction}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="4">
                    <Configuration
                      location={this.state.location}
                      mockServiceName={this.state.mockServiceName}
                      updateMockServiceName={this.updateMockServiceName}
                      exportSelected={this.getInitLocation}
                      onChangeLocation={location => this.locationChanged(location)}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="5" className={'h-100 '}>
                    <Run
                      status={this.state.configState}
                      mockService={this.state.mockServiceName}
                      endpoint={this.state.msEndpoint}
                      exampleUrl={exampleURL}
                      service={this.state.service as string}
                      location={this.state.location ? this.state.location.shipName : ''}
                      transactions={this.state.wzTransactions.transactions.length}
                      runMockService={this.executeWizard}
                      creationInProgress={this.state.creationInProgress}
                      deployInProgress={this.state.deployInProgress}
                      onClose={this.onCloseHandler}
                      deployError={this.state.deployError}
                      restart={this.initialWizardState}
                      doneButton={this.props.doneButton}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="6">
                    <Leave
                      goToPrevious={() => {
                        this.setNewState(this.state.lastTabSelected);
                      }}
                      onClose={this.onCloseHandler}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
              <div className={clsx(styles.wizardFooter, 'text-right')}>
                {this.state.showBackButton &&
                  (resolver.disableBack ? (
                    <OverlayTrigger
                      delay={200}
                      rootClose={true}
                      placement="top"
                      overlay={<Tooltip id="tooltip-disabled">{resolver.hintMsg}</Tooltip>}
                    >
                      <span className="btn disabled" onClick={(event: any) => event.preventDefault()}>
                        {i18n.t('common:actions.back')}
                      </span>
                    </OverlayTrigger>
                  ) : (
                    <Button style={{ marginRight: '10px' }} variant="secondary" onClick={() => this.backAction()}>
                      {i18n.t('common:actions.back')}
                    </Button>
                  ))}
                {this.state.showNextButton &&
                  (resolver.disableNext ? (
                    <OverlayTrigger
                      delay={200}
                      rootClose={true}
                      placement="top"
                      overlay={<Tooltip id="tooltip-disabled">{resolver.hintMsg}</Tooltip>}
                    >
                      <span className="btn disabled" onClick={(event: any) => event.preventDefault()}>
                        {i18n.t('common:actions.next')}
                      </span>
                    </OverlayTrigger>
                  ) : (
                    <Button variant="primary" onClick={() => this.nextAction()}>
                      {i18n.t('common:actions.next')}
                    </Button>
                  ))}
              </div>
            </div>
          </Col>
        </Row>
      </Modal>
    );
  }
}

type DispatchProps = {
  createService: (serviceName: string) => Promise<Service>;
  showToastNotification: (type: ToastType, heading: string, content?: any, messageTimeout?: number) => void;
  setPageFilter: (filter: PageFilterContent) => void;
  fetchVirtualServices: (forceRefresh?: boolean) => Promise<void>;
  toggleExpandedMockServiceRow: (mockServiceId: number | null) => void;
  getMockServiceListThunk: () => void;
};

// Bound with dispatch so we can reuse the promise created by createService call
const mapDispatchToProps = (dispatch: any) => ({
  createService: (serviceName: string) => dispatch(createServiceThunk(serviceName)),
  showToastNotification: (type: ToastType, heading: string, content?: any, messageTimeout?: number) =>
    dispatch(showToastNotification(type, heading, content, messageTimeout)),
  setPageFilter: (filter: PageFilterContent) => dispatch(setPageFilter(filter)),
  fetchVirtualServices: (forceRefresh?: boolean) => dispatch(fetchServices(forceRefresh)),
  toggleExpandedMockServiceRow: (mockServiceId: number | null) => dispatch(toggleExpandedMockServiceRow(mockServiceId)),
  getMockServiceListThunk: () => dispatch(getMockServiceListThunk()),
});

const mapStateToProps = ({ ui, services, transactions }: ApplicationState) => {
  return {
    selectedServiceId: ui.pageFilter.serviceId,
    services: services.services,
    transactions: transactions,
  };
};

type MapToStateProps = ReturnType<typeof mapStateToProps>;
export default connect(mapStateToProps, mapDispatchToProps)(WizardModal);
